import { AxiosResponse } from "axios";

export const extractFileNameFromHeaders = (response: AxiosResponse<Blob>): string | null => {
    const contentDisposition = response.headers['content-disposition'] as string | undefined;
    if (contentDisposition) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
        if (matches?.[1]) {
            return matches[1].replace(/['"]/g, '');
        }
    }
    return null;
}